import { site, categories } from "@/mocks/heigua";

const heroStats = [
  { value: "430+", label: "累计归档期数" },
  { value: "2018—2026", label: "时间跨度" },
  { value: "36 套", label: "经典合集" },
  { value: "6 大", label: "覆盖分类" },
];

export default function Hero() {
  const quickCats = categories.slice(1, 6);
  return (
    <section id="start" className="relative overflow-hidden bg-primary-950">
      {/* 背景图 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20aged%20cream%20archive%20wall%20with%20vertical%20filing%20folders%2C%20vintage%20press%20cutting%20textures%20and%20faint%20ink%20typography%2C%20abstract%20editorial%20backdrop%2C%20deep%20terracotta%20and%20burnt%20amber%20mood%2C%20soft%20dramatic%20light%2C%20cinematic%20atmosphere%2C%20no%20readable%20text%2C%20high%20detail&width=1800&height=1080&seq=hg-hero&orientation=landscape"
          alt="黑瓜档案馆暖色档案墙背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-950/55 to-background-50" />
        <div className="absolute inset-0 bg-[radial-gradient(oklch(var(--accent-500)/0.14),transparent_60%)] opacity-70" />
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-16 pt-28 md:px-6 md:pb-24 md:pt-40">
        <div className="mx-auto w-full max-w-3xl text-center">
          <p className="mx-auto inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-primary-900/60 px-4 py-1.5 text-xs text-accent-200 backdrop-blur-sm">
            <i className="ri-time-line" />
            往期整理 · 陈年旧料 · 经典合集，慢慢翻
          </p>
          <h1 className="mt-6 font-heading text-4xl font-black leading-tight tracking-tight text-background-50 md:text-6xl">
            黑瓜旧瓜考古
            <span className="mx-2 inline-block text-accent-400">·</span>历史回顾
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-background-200/90 md:text-lg">
            {site.desc}
          </p>

          <div className="mx-auto mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#library"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400 sm:w-auto"
            >
              进档案库检索旧料
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#timeline"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/40 bg-background-50/5 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/15 sm:w-auto"
            >
              看年份时间线
              <i className="ri-time-line" />
            </a>
          </div>

          <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
            {quickCats.map((c) => (
              <a
                key={c.key}
                href="#library"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200/25 px-3 py-1 text-xs text-background-100/90 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className={c.icon} />
                {c.label}
              </a>
            ))}
          </div>
        </div>

        {/* 数据条 */}
        <dl className="mx-auto mt-14 grid w-full max-w-4xl grid-cols-2 gap-3 md:grid-cols-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-200/20 bg-background-50/5 px-4 py-4 text-center backdrop-blur-sm"
            >
              <dt className="order-2 mt-1 block text-xs text-background-200/80">{s.label}</dt>
              <dd className="font-heading text-2xl font-bold text-accent-300">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}